import { useEffect, useState } from "react";
import {
    Label,
} from "reactstrap";
import Select from "react-select";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { propertyListGetRequest } from "store/auth/action";
import { ApplicationState } from "store";
import { isJson } from "utils";

interface DtsSelectInputProps {
    label?: string;
    type?: string;
    value?: any;
    placeholder?: string;
    onChange: (value: string) => void;
    name?: string;
    model?: string
}

const DtsSelectInput: React.FC<DtsSelectInputProps> = ({ model, label, type, placeholder, onChange, name, value}: any) => {
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const optionList = useSelector((state: ApplicationState) => state.auth.optionmetaData);
    const [options, setOptions] = useState([]);
    const [filterObject, setFilterObject] = useState<any>({
        pageSize: 100
    });

    const handletypetext = (
        inputValue: string
    ) => {
        const filters = {...filterObject, search: inputValue}
        setFilterObject(filters)
        setTimeout(() => {
            if(inputValue) {
                dispatch(propertyListGetRequest(model, filters));
            }
        }, 1000);
    };

    useEffect(() => {
        let FilterObject = {pageSize: 100}
        setTimeout(() => {
            dispatch(propertyListGetRequest(model, FilterObject));
        }, 1000);
    }, [model])

    useEffect(() => {
        let options: any = []
        optionList && optionList.length && optionList.map((item: any) => {
            let valueJson =item.valuesJson && isJson(item.valuesJson) ? JSON.parse(item.valuesJson) : item?.valuesJson
            if(valueJson?.key ==='email' || valueJson?.key === 'phone_number'  || valueJson?.key === 'alternate_email_address' || valueJson?.key === 'mobile'  || valueJson?.key === 'name'  || valueJson?.key === 'first_name'   || valueJson?.key === 'last_name'){
                options.push({ label: valueJson?.label, value: valueJson?.key, valueJson: valueJson })
            }
        })
        setOptions(options)
    }, [optionList])
    
    return (
        <div>
            {
                <div>
                    {label ? <Label htmlFor={name} className="form-label mt-1 fw-bold fs-16 form-label">{label}<span id={`${name}`} className="d-none fw-bold text-danger">{" "}*</span></Label> : null}
                    <Select isMulti type={type} options={options || []} value={value} id={name} placeholder={placeholder} onChange={(selectedOption: any) => onChange(selectedOption)}  onInputChange={(inputValue: any) => handletypetext(inputValue)}></Select>
                </div>
            }
        </div>
    );
};

export default DtsSelectInput;
